import { render, staticRenderFns } from "./TypeInsuranceForm.vue?vue&type=template&id=764c1c60"
import script from "./TypeInsuranceForm.vue?vue&type=script&lang=js"
export * from "./TypeInsuranceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports